'use strict';

var React = require('react');

const getChildKey = (child) => child.key || "";
function onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    React.Children.forEach(children, (child) => {
        if (React.isValidElement(child))
            filtered.push(child);
    });
    return filtered;
}

exports.getChildKey = getChildKey;
exports.onlyElements = onlyElements;
//# sourceMappingURL=utils.cjs.map
